import angular from 'angular';


const timingStrategyConstants = angular.module('ttb.constants.timingStrategy', [])
    .constant('CALCULATION_TYPE', {
        EDGES: 1,
        START_AND_DURATION: 2,
        END_AND_DURATION: 3,
        DAYS_OVERRIDE: 4,
        DURATION_FOR_EXISTING_INTERVAL: 5,
        EDGES_FOR_EXISTING_INTERVAL: 6
    }).name;
    
export default timingStrategyConstants;


// WEBPACK FOOTER //
// ../constants/timing-strategy.constants.js